require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 846
// module chunks = 0